<ng-container *puLet="organizations$ | async as organizations">
  <ng-container *puLet="breakpoints$ | async as breakpoints">
    @if (organizations) {
      <pu-select
        class="header-select"
        [formControl]="orgCtrl"
        [isReadonly]="hasSingleOrg"
        [items]="organizations"
        [label]="
          !breakpoints.isTablet
            ? ('shell.header.teamSelector.label' | translate)
            : ''
        ">
      </pu-select>

      @if (breakpoints.isTablet) {
        <div class="header-select_label">
          {{ 'shell.header.teamSelector.label' | translate }}
        </div>
      }
    } @else {
      <div class="header-select pp-shimmer"></div>
    }
  </ng-container>
</ng-container>
